<template>
  <div>
    <div v-show="value" class="overlay"></div>
    <div v-show="value" class="tablePopup">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn v-if="showNavigator" small flat @click="getPreviousItem" :disabled="getPreviousItemDisabled"><v-icon large>arrow_left</v-icon>Previous</v-btn>
          <v-toolbar-title class="mx-auto">
            {{title}}
          </v-toolbar-title>
          <v-menu v-if="isShowSettingIcon" offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon flat>
                <v-icon>settings</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-tile>
                <v-list-tile-title>{{ $t('escToClosePopup') }}</v-list-tile-title>
                <v-list-tile-action>
                  <v-switch v-model="isEscClose" color="info" class="ml-2"></v-switch>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn v-if="showNavigator" small flat @click="getNextItem" :disabled="getNextItemDisabled">Next<v-icon large>arrow_right</v-icon></v-btn>
        </v-toolbar>
        <v-card-text ref="simplePopupContainer">
          <div ref="details">
            <v-form ref="form" v-model="isValid" lazy-validation>
              <v-alert
                v-if="hasAlert"
                v-model="errorAlert"
                dismissible
                type="error">{{$t(errorMessage)}}</v-alert>
              <slot name="input"></slot>
            </v-form>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions v-if="!hideFooter">
          <v-layout row justify-space-between>
            <v-flex class="text-xs-left" v-if="!hideLftBtn"><slot name="left_button"><v-btn color="primary" flat @click.stop="firstMethod" :disabled="isLoading">{{leftButtonText}}</v-btn></slot></v-flex>
            <v-flex class="text-xs-right" v-if="!hideRgtBtn">
                <slot name="control1"></slot>
                <slot name="right_button">    
                  <LoaderButton
                    :buttonText="rightButtonText"
                    :promiseAwait="onSubmitted"
                    :disabled="!isValid || rightButtonDisabled"
                    :loading="rightButtonLoading"
                    v-model="isLoading"
                    @loaderButtonError="loaderButtonError"
                    class="ml-3"/>
                </slot>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>

import SimpleTextPopup from './SimpleTextPopup'
import LoaderButton from './LoaderButton'

export default {
  name: 'formSubmitPopup',
  components: {
    LoaderButton
  },
  extends: SimpleTextPopup,
  data () {
    return {
      isLoading: false,
      isValid: true,
      errorAlert: false,
      errorMessage: ''
    }
  },
  methods: {
    clearAlert () {
      this.errorAlert = false
      this.errorMessage = ''
    },
    validate () {
      return this.$refs.form.validate()
    },
    onSubmitted () {
      this.errorAlert = false
      if (!this.validate()) return Promise.reject(Error(this.$t('dataMissing')))
      return this.secondMethod()
        .catch((error) => {
          this.loaderButtonError(error.message)
          console.error(error)
          throw error
        })
    },
    loaderButtonError (error) {
      if (this.hasAlert) {
        this.errorAlert = true
        this.errorMessage = error
      }
      this.$emit('loaderButtonError', error)
    },
    escClose (e) {
      if (this.value && this.isShowSettingIcon && this.isEscClose && e.keyCode === 27 && this.currentPopup === this.popupId && !this.isLoading) {
        this.hideMethod(0)
      }
    }
  },
  props: {
    isShowSettingIcon: {
      type: Boolean,
      default: true
    },
    hasAlert: {
      type: Boolean,
      default: false
    },
    rightButtonLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
 .tablePopup {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 90%;
  transform: translate(-50%, -50%);
}

.tablePopup >>> .v-card__text {
  max-height: 80vh;
  overflow: auto;
}

.tablePopup >>> .container {
  max-width: 100%;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .3s cubic-bezier(.25,.8,.5,1);
  transition: .3s cubic-bezier(.25,.8,.5,1);
  /* z-index: 5; */
  background-color: rgba(0, 0, 0, 0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/TablePopup.vue